import React from 'react';

export const Loader = () => {
  return (
    <div className="loaders-container">
      <div className="circleloader"></div>
    </div>
  );
};
